import React from "react";
import { Icon, IconProps } from "../Icon";
/**
 * @group Icons
 */
export function FlashOnIcon(props: IconProps) {
    return <Icon {...props} iconKey={"flash_on"}/>
}
